import React from 'react';

export default function () {
  const env = global.pbgEnv;
  const { REACT_APP_FB_APP_ID } = env;

  /* eslint-disable */
  window.fbAsyncInit = function() {
    FB.init({
      appId: REACT_APP_FB_APP_ID,
      xfbml: true,
      version: 'v2.12'
    });
  };
  (function(d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {return;}
    js = d.createElement(s); js.id = id;
    js.src = '//connect.facebook.net/en_US/sdk.js';
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'facebook-jssdk'));
  /* eslint-enable */

  return <noscript />;
}



// WEBPACK FOOTER //
// ./src/components/facebook-script.js